import React, { useEffect, useState } from "react";

import { useDispatch } from "react-redux";
import { hideRightSidebar, changeMainTheme } from "../../store/layout/actions";

//SimpleBar
import SimpleBar from "simplebar-react";

import { Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";

import "./rightbar.scss";
//Import images
import layout1 from "../../assets/images/layouts/layout-1.jpg";
import layout2 from "../../assets/images/layouts/layout-2.jpg";

//Component
import SwitchHotkey from "../CommonForBoth/TopbarDropdown/SwitchHotkey";
import LanguageDropdown from "../CommonForBoth/TopbarDropdown/LanguageDropdown";
import AudioComponent from "../Common/AudioComponent";

const RightSidebar = ({ t }) => {
  const dispatch = useDispatch();
  const [mainTheme, setMainTheme] = useState("");
  let [volume, setVolume] = useState(AudioComponent.volume);

  /**
   * Hides the right sidebar
   */
  const hideRightbar = (e) => {
    e.preventDefault();
    dispatch(hideRightSidebar());
  };

  useEffect(() => {
    setMainTheme(mainTheme);
  }, [mainTheme]);

  // change topbar theme
  const changeMainThemeFunc = (theme) => {
    dispatch(changeMainTheme(theme));
  };

  const volumeCtrl = () => {
    AudioComponent.setVolume(volume)
  };

  useEffect(() => {
    volumeCtrl();
    localStorage.setItem("Volume", volume);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [volume]);
  return (
    <React.Fragment>
      <div className="right-bar">
        <SimpleBar style={{ height: "900px" }}>
          <div data-simplebar className="h-100">
            <div className="rightbar-title px-3 py-4">
              <Link
                to="#"
                onClick={hideRightbar}
                className="right-bar-toggle float-right"
              >
                <i className="mdi mdi-close noti-icon"></i>
              </Link>
              <h5 className="m-0">{t("Settings")}</h5>
            </div>

            <hr className="my-0" />
            <div className="mt-3">
              <h6 className="text-center m-0">{t("Language")}</h6>
              <div className="text-center">
                <LanguageDropdown />
              </div>
            </div>

            <div className="m-1">
              <h6 className="text-center m-0">{t("Send With Enter")}</h6>
              <div className="text-center mt-2">
                <SwitchHotkey></SwitchHotkey>
              </div>
            </div>
            
            <h6 className="text-center mt-3">{t("Volume")}</h6>
            <div className="text-center">
              <i
                className={`bx ${
                  volume > 50
                    ? "bx-volume-full"
                    : volume < 50 && volume > 1
                    ? "bx-volume-low"
                    : "bx-volume-mute"
                }  font-size-22 mr-2`}
                onClick={() => {
                  volume !== 0 ? setVolume(0) : setVolume(100);
                }}
              ></i>
              <input
                id="audio"
                type="range"
                min="0"
                max="100"
                onChange={() => {
                  setVolume(document.getElementById("audio").value);
                }}
                value={volume}
              ></input>
            </div>
            <div className="p-4">
              <h6 className="text-center">{t("Mode")}</h6>

              <div className="mb-2">
                <Link to="#" onClick={() => changeMainThemeFunc("light")}>
                  <img
                    src={layout1}
                    className="img-fluid img-thumbnail"
                    alt="Light-Theme"
                  />
                </Link>
              </div>

              <div className="mb-2">
                <Link to="#" onClick={() => changeMainThemeFunc("dark")}>
                  <img
                    src={layout2}
                    className="img-fluid img-thumbnail"
                    alt="Dark-Theme"
                  />
                </Link>
              </div>
            </div>
          </div>
        </SimpleBar>
      </div>
      <div className="rightbar-overlay"></div>
    </React.Fragment>
  );
};

export default withTranslation()(RightSidebar);
